import { render, staticRenderFns } from "./SearchClients.vue?vue&type=template&id=7dd4e7b4&"
import script from "./SearchClients.vue?vue&type=script&lang=js&"
export * from "./SearchClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports